const labels = {
  All: { 'See the offering': 'Ver la oferta' },
  FacilityDetails: { 'Ref: Page title': 'Detalles de la instalación', 'Ref: Review': 'Revisar' },
  FacilitiesList: { 'Ref: Page title': 'Instalaciones', 'Ref: See details': 'Ver detalles' },
};
export default labels;
